module.exports = __webpack_public_path__ + "static/media/21.7d34d1fd.png";